<template>
	<div class="pagination-container" ref="container">
		<span class="previous-page-button"
			:class="{disabled: prevPageDisabled}"
			@click="prevPageDisabled ? () => {} : $emit('pageClick', paging.current_page - 1)">
		</span>

		<span v-for="n in nPageAround" :key="'before' + n">
			<span v-if="(paging.current_page - (nPageAround - n + 1)) > 0"
				class="page-item"
				@click="$emit('pageClick', (paging.current_page - (nPageAround - n + 1)))"
				>{{(paging.current_page - (nPageAround - n + 1))}}</span>
		</span>

		<span class="page-item current">{{paging.current_page}}</span>

		<span v-for="n in nPageAround" :key="'after' + n">
			<span v-if="paging.current_page + n <= paging.last_page"
				class="page-item"
				@click="$emit('pageClick', paging.current_page + n)"
				>{{paging.current_page + n}}</span>
		</span>

		<span class="next-page-button"
			:class="{disabled: nextPageDisabled}"
			@click="nextPageDisabled ? () => {} : $emit('pageClick', paging.current_page + 1)">
		</span>

		<button class="btn btn-sm btn-blue ml-4" @click="onJumpClick">{{$t('jump')}}</button>

	</div>
	
</template>

<script>
import promptConfirm from '../../mixins/prompt-confirm';
export default {
	props: {
		paging: {
			type: Object
		},
		isLoading: { type: Boolean },
		nPageAround: { type: Number, default: 5},
		hasJumpButton: { type: Boolean, default: false}
	},
	mixins: [promptConfirm],
	computed: {
        prevPageDisabled() {
            return this.paging.total === 0 || this.paging.current_page === 1 || this.isLoading;
        },
        nextPageDisabled() {
            return this.paging.total === 0 || this.paging.current_page === this.paging.last_page || this.isLoading;
        },
	},
	methods: {
		onJumpClick(e) {
			e.target.blur();
			this.promptInput(
				this.$t('jump'),
				this.$t('please_enter_page_to_jump'),
				null,
				null,
				(page) => {
					if (!page) {
						return;
					}
					if (page >= 1 && page <= this.paging.last_page) {
						this.$emit('pageClick', page);
					} else {
						this.promptAlert(this.$t('incorrect_page'));
					}
				}
			);
		}
	}
}
</script>

<style lang="scss" scoped>

.pagination-container {
	display: flex;
    justify-content: flex-end;
    align-items: center;
	font-size: 16px;
}

.page-item {
	display: inline-block;
	margin: 0 0.3em;
	font-size: 1em;
	color: #90A4AE;
	cursor: pointer;
	width: 1.6em;
	height: 1.4em;
	text-align: center;

	&.current, &:hover {
		font-weight: bold;
		border: 1px solid #ccc;;
		width: 1.6em;
		background: white;
		border-color: #ccc;;
		border-radius: 0.2em;
		display: inline-flex;
		justify-content: center;
		align-items: center;
	}
}


</style>

<i18n>
{
	"en": {
		"jump": "Jump to",
		"please_enter_page_to_jump": "Please enter target page number",
		"incorrect_page": "Invalid page to jump to."
	},
	"zh": {
		"jump": "跳頁",
		"please_enter_page_to_jump": "請輸入目標頁數",
		"incorrect_page": "請輸入正確的頁數"
	}
}
</i18n>